import React, { useState } from 'react';
import '../styles/login.css';
import Apis from '../services/apis';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const apis = new Apis();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isResetMode, setIsResetMode] = useState(false);

  const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');
    const [tempCognitoUser, setTempCognitoUser] = useState(null);
  
    const handleResetSubmit = async(e) => {
      e.preventDefault();
      setError('');
  
      if (newPassword !== confirmPassword) {
        setError('Passwords do not match');
        return;
      }
  
      try {
        const result = await apis.completeNewPassword(
          tempCognitoUser,
          newPassword
        );
        localStorage.clear();
        localStorage.setItem("email", email);
        localStorage.setItem("access_token", result.accessToken);
        localStorage.setItem("refresh_token", result.refreshToken);
        localStorage.setItem(
          "access_token_expires_at",
          result.accessTokenExpiresAt
        );
    
        alert("Password reset successful!!");
        navigate("/family-office");
      } catch (err) {
        alert(err.message);
      }
    };

  
    const toggleNewPasswordVisibility = () => {
      setShowNewPassword(!showNewPassword);
    };
  
    const toggleConfirmPasswordVisibility = () => {
      setShowConfirmPassword(!showConfirmPassword);
    };


    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
    
      try {
        const result = await apis.loginUser(email, password);
    
        // 🔴 CASE 1: User must set new password
        if (result.status === "NEW_PASSWORD_REQUIRED") {
          alert("You need to set a new password.");
          setIsResetMode(true);
          // Store user temporarily (state / context)
          setTempCognitoUser(result.user);

          return;
        }
    
        // 🟢 CASE 2: Login successful
        if (result.status === "SUCCESS") {
          const {
            accessToken,
            refreshToken,
            accessTokenExpiresAt,
          } = result;

          localStorage.clear();
          localStorage.setItem("email", email);
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem(
            "accessTokenExpiresAt",
            accessTokenExpiresAt.toString()
          );
          let roleRes = await apis.userRole();
          roleRes = roleRes?.data;
          if(roleRes.is_admin)
          {
            roleRes["roles"] = [
              {
                  "role_name": "Admin"
              }
          ]
          }
          localStorage.setItem("user_id", roleRes.user_id);
          localStorage.setItem("organization_id", roleRes.organization_id);
          localStorage.setItem("roles", JSON.stringify(roleRes.roles));
          localStorage.setItem("user_name", roleRes.user_name);
          if(roleRes.roles.filter((role) => {return role.role_name === "Terminal Officer"}).length > 0)
          // {navigate("/family-office")}
          navigate("/family-dashboard")
          else if(roleRes.roles.filter((role) => {return  role.role_name === "Admin"}).length > 0)
            {navigate("/orgs")}
          else if(roleRes.roles.filter((role) => {return role.role_name === "Terminal Client"}).length > 0)
            {navigate(`/client-holdings?id=${roleRes.user_id}&&name=${roleRes.user_name}`);}
          else{
            alert("Unauthorized User. Contact Support.");
          }
        }
      } catch (err) {
        alert("Error logging in: " + err.message);
      } finally {
        setLoading(false);
      }
    };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  if(!isResetMode)
  {
    return (
      <div className="page-container">
        <div className="xcontainer">
          <div className="branding">
          <img
            src="https://cdn.prod.website-files.com/6704fe9ff2554866b346ff70/6949702df1e902a9654a063a_Pricing%20Culture.JPG"
            alt="Pricing Culture Logo"
            className="logo-img"
            style={{ paddingTop: '10px' }}
          />
          </div>

          <h1 className="title">Login</h1>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                className="form-input"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <div className="input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-input password-input"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="forgot-password">
              <div className='fp' onClick={()=>navigate("/reset")}>Forgot Password?</div>
            </div>

            <button type="submit" className="submit-btn" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
              {!loading
              ?
              ("Login")
              :
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  border: '10px solid rgba(255,255,255,0.2)',
                  borderTop: '10px solid #F4A31E',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              />}
            </button>
          </form>
        </div>
      </div>
    )
  }
  else{
    return(
      <div className="page-container">
      <div className="xcontainer">
        <div className="branding">
        <img
          src="https://cdn.prod.website-files.com/6704fe9ff2554866b346ff70/6949702df1e902a9654a063a_Pricing%20Culture.JPG"
          alt="Pricing Culture Logo"
          className="logo-img"
          style={{ paddingTop: '10px' }}
        />
        </div>

        <h1 className="title" >Reset Password</h1>

        <form onSubmit={handleResetSubmit} >
          <div className="form-group">
            <div className="input-wrapper">
              <input
                type={showNewPassword ? 'text' : 'password'}
                className="form-input password-input"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={toggleNewPasswordVisibility}
              >
                {showNewPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="form-group">
            <div className="input-wrapper">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                className="form-input password-input"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={toggleConfirmPasswordVisibility}
              >
                {showConfirmPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="submit-btn" style={{marginTop:20,display:'flex', justifyContent:'center', alignItems:'center'}}>
            
            {!loading
              ?
              ("Reset Password")
              :
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  border: '10px solid rgba(255,255,255,0.2)',
                  borderTop: '10px solid #F4A31E',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              />}
          </button>
        </form>
      </div>
      </div>
      );
  };
};

export default Login;